<template>
    <div class="w-full">
        <div class="w-full lg:w-1/2 bg-white rounded-lg overflow-hidden shadow-md">
            <div class="flex flex-row items-center justify-between p-4">
                <h1 class="text-lg">Recent Stream Sales</h1>
                <span class="px-3 py-1 bg-gray-100 text-gray-500 rounded-full uppercase text-sm">Past Year</span>
            </div>
            <div class="h-40">
                <VueApexCharts type="area" height="100%" ref="salesChart" :options="chartOptions" :series="series" />
            </div>
        </div>

        <div class="w-full mt-8">
            <div>
                <div class="sm:hidden">
                    <label for="tabs" class="sr-only">Select a tab</label>
                    <select id="tabs" name="tabs"
                        class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
                        v-model="statusFilter">
                        <option value="all">All Sales</option>
                        <option value="occurring">In Progress Sales</option>
                        <option value="complete">Completed Sales</option>
                    </select>
                </div>

                <div class="flex flex-row items-center">
                    <div class="hidden sm:block flex-1">
                        <nav class="flex space-x-4" aria-label="Tabs">
                            <button class="px-3 py-2 font-medium text-sm rounded-md focus:outline-none" :class="{
                                'text-gray-500 hover:text-gray-700': statusFilter !== 'all',
                                'bg-blue-100 text-blue-700': statusFilter == 'all'
                            }" @click="statusFilter = 'all'">
                                All
                            </button>
                            <!-- <button
                class="px-3 py-2 font-medium text-sm rounded-md focus:outline-none"
                :class="{
                  'text-gray-500 hover:text-gray-700':
                    statusFilter !== 'pending',
                  'bg-blue-100 text-blue-700': statusFilter == 'pending'
                }"
                @click="statusFilter = 'pending'"
              >
                Downloaded
              </button> -->
                            <button class="px-3 py-2 font-medium text-sm rounded-md focus:outline-none" :class="{
                                'text-gray-500 hover:text-gray-700':
                                    statusFilter !== 'occurring',
                                'bg-blue-100 text-blue-700': statusFilter == 'occurring'
                            }" @click="statusFilter = 'occurring'">
                                In Progress
                            </button>
                            <button class="px-3 py-2 font-medium text-sm rounded-md focus:outline-none" :class="{
                                'text-gray-500 hover:text-gray-700':
                                    statusFilter !== 'complete',
                                'bg-blue-100 text-blue-700': statusFilter == 'complete'
                            }" @click="statusFilter = 'complete'">
                                Complete
                            </button>
                        </nav>
                    </div>
                    <div class="hidden sm:block">
                        <Dropdown class="ml-4"
                            buttonClass="rounded-full flex  text-gray-400 hover:text-gray-600 focus:outline-none z-0">
                            <template #trigger>
                                <span class="flex items-center h-5 w-5 text-lg">
                                    <i class="far fa-ellipsis-h transform rotate-90"></i>
                                </span>
                            </template>
                            <template #dropdown>
                                <div class="py-1" role="none">
                                    <button
                                        class="text-left w-full block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                        role="menuitem">
                                        Menu Option
                                    </button>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>

            <ul class="mt-4 space-y-2 divide-gray-200">
                <li v-for="sale in filteredSales" v-bind:key="sale.id">
                    <div class="block bg-white rounded-md overflow-hidden">
                        <div class="px-4 py-4 sm:px-6">
                            <div class="flex items-center justify-between">
                                <p class="text-sm font-medium text-gray-800 truncate">
                                    {{ sale.created_at }}
                                </p>
                                <div class="ml-2 flex-shrink-0 flex">
                                    <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                                        v-if="sale.status == 'pending'">
                                        Downloaded
                                    </p>
                                    <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                                        v-if="sale.status == 'complete'">
                                        Complete
                                    </p>
                                    <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                                        v-if="sale.status == 'occurring'">
                                        In Progress
                                    </p>
                                </div>
                            </div>
                            <div class="mt-2 sm:flex sm:justify-between">
                                <div class="sm:flex">
                                    <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1">
                                        <!-- Heroicon name: solid/users -->
                                        <span class="flex-shrink-0 h-5 w-5 flex items-center">
                                            <i class="fad fa-building"></i>
                                        </span>
                                        <p>
                                            {{ sale.network.name }}
                                        </p>
                                    </div>
                                    <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                                        v-if="sale.status !== 'pending'">
                                        <!-- Heroicon name: solid/users -->
                                        <span class="flex-shrink-0 h-5 w-5 flex items-center">
                                            <i class="fas fa-coins"></i>
                                        </span>
                                        <p>${{ sale.stringer_cut }}</p>
                                    </div>
                                    <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6" v-tippy
                                        title="Invoice Reference" v-if="sale.status !== 'pending'">
                                        <!-- Heroicon name: solid/users -->
                                        <span class="flex-shrink-0 h-5 w-5 flex items-center">
                                            <i class="fad fa-file-invoice"></i>
                                        </span>
                                        <p>
                                            {{ sale.invoice_number }}
                                        </p>
                                    </div>
                                </div>

                                <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1">
                                    <!-- Heroicon name: solid/calendar -->
                                    <span class="flex-shrink-0 h-5 w-5 flex items-center">
                                        <i class="fad fa-calendar-check"></i>
                                    </span>
                                    <p>
                                        {{
                                            sale.status !== "pending"
                                                ? "Purchased on "
                                                : "Downloaded on "
                                        }}
                                        <span>{{ sale.created_at | displayLocalDateTime("M/D/YYYY") }}
                                            at
                                            {{
                                                sale.created_at | displayLocalDateTime("h:mm a")
                                            }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li v-if="polling">
                    <div class="flex items-center justify-center py-5">
                        <h1 class="text-2xl">
                            <i class="fa fa-circle-notch fa-spin text-black"></i>
                        </h1>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import * as Config from "@/config";

import moment from "moment";
import Card from "@/components/partials/Card";
import CustomTable from "@/components/general/CustomTable";
import Dropdown from "@/components/partials/Dropdown";
import VueApexCharts from "vue-apexcharts";

export default {
    name: "HelloWorld",
    data() {
        return {
            sales: [],
            statusFilter: "all",

            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            polling: true,

            series: [
                {
                    name: "Sales",
                    data: []
                }
            ],
            chartOptions: {
                chart: {
                    type: "area",
                    toolbar: {
                        show: false
                    },
                    selection: {
                        enabled: false
                    },
                    sparkline: {
                        enabled: true
                    },
                    zoom: {
                        enabled: false
                    }
                },
                grid: {
                    show: false,
                    padding: {
                        top: 4,
                        left: 0,
                        right: 0,
                        bottom: 0
                    }
                },
                stroke: {
                    curve: "smooth"
                },
                tooltip: {
                    x: {
                        show: true
                    },
                    y: {
                        formatter: function (value) {
                            return Math.round(value);
                        }
                    }
                }
            }
        };
    },
    components: {
        Card,
        CustomTable,
        Dropdown,
        VueApexCharts
    },
    mounted() {
        this.getSalesGraphData();
        this.getSales();
    },
    methods: {
        getSales() {
            var _this = this;
            this.$http
                .get(Config.apiPath + "/api/v2/stringer/sales/stream")
                .then(response => {
                    this.$set(this, "sales", response.data);
                    this.$set(this, "polling", false);
                    this.calculateTotal();
                });
        },
        getSalesGraphData() {
            return this.$http
                .get(Config.apiPath + "/api/v2/stringer/graphs/sales", {
                    params: {
                        new: true,
                        filter: "year",
                        timezone: this.timezone,
                        type: 'stream_sale_logs'
                    }
                })
                .then(response => {
                    let newData = [];
                    for (const [key, value] of Object.entries(response.data)) {
                        newData.push({
                            x: moment(key, "YYYY-MM").format("MMMM, YYYY"),
                            y: value
                        });
                    }
                    this.series[0].data = newData;
                    this.createSalesGraph();
                });
        },
        createSalesGraph() {
            this.$refs.salesChart.updateSeries(
                [
                    {
                        data: this.series[0].data
                    }
                ],
                false,
                true
            );
        }
    },
    computed: {
        filteredSales: function () {
            if (this.statusFilter == "all" || this.statusFilter == null)
                return this.sales;

            const filter = sale => sale.status.includes(this.statusFilter);

            return this.sales.filter(filter);
        }
    }
};
</script>
